import { render, staticRenderFns } from "./RightIcon.vue?vue&type=template&id=3b7eccb5&scoped=true&"
import script from "./RightIcon.vue?vue&type=script&lang=js&"
export * from "./RightIcon.vue?vue&type=script&lang=js&"
import style0 from "./RightIcon.vue?vue&type=style&index=0&id=3b7eccb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7eccb5",
  null
  
)

export default component.exports